import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const SupportTemplateUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  title, onTitleChange, titleError, setTitleError,
  body, onBodyChange, bodyError, setBodyError,
  message, onMessageChange, messageError, setMessageError,
  parentTemplate, onparentTemplateChange, parentTemplateError, setparentTemplateError, parentList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update keywords'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='title' label='Title' maxLength={20} required={true}
      value={title} onChange={onTitleChange}
      error={titleError} setError={setTitleError}
      autoFocus={true}
    />
    <InputTextSF type='text' name='body1' label='Body' maxLength={500}
      value={body} onChange={onBodyChange}
      error={bodyError} setError={setBodyError}
    />
    <InputTextSF type='text' name='message' label='Message' maxLength={500}
      value={message} onChange={onMessageChange}
      error={messageError} setError={setMessageError}
    />
    <InputSelectSF type='select' name='parentTemplate' required={true} label='Parent Template'
      value={parentTemplate} optionList={parentList}
      onChange={onparentTemplateChange} error={parentTemplateError} setError={setparentTemplateError}
    />
  </ModalFormUI>

export default SupportTemplateUpdateModalUI
